module.exports = __webpack_public_path__ + "static/media/picasso-4.5447eb42.jpeg";